import { render } from "./BroadcastChatCard.vue?vue&type=template&id=601786d8"
import script from "./BroadcastChatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastChatCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/Broadcast/BroadcastChatCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "601786d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('601786d8', __exports__)) {
    api.reload('601786d8', __exports__)
  }
  
  module.hot.accept("./BroadcastChatCard.vue?vue&type=template&id=601786d8", () => {
    api.rerender('601786d8', render)
  })

}


export default __exports__